module.exports = __webpack_public_path__ + "img/aquarium.b6135c7b.svg";